import React, { FC, useEffect, useRef, useState } from 'react';
import Props from './typing';
import imgURL from '../../../../lib/imgURL';
import { headerDropdownDetails } from '../../../../components/SideBar/sidebar.constant';
import './style.scss';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Product } from '../../../../screens/Home/LandingPage/typing';
import { getProductData } from '../../../../screens/Home/LandingPage/landingPage.constants';
import { updateSelectedProductOnPathChange } from '../../../../redux/actions/login';
import useRedirect from '../../../../hooks/useRedirect';
import { getSelectedProduct } from '../../../../lib/helper';
import { isCitiTheme } from '../../../../lib/analyticsUtil';

const HeaderDropdown: FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mappedProducts } = props.loginState;
  const { isCollapsed } = props;
  const [products, setProducts] = useState<Product[]>([]);
  const { push, generatePath } = useRedirect();
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();
  const isCiti = isCitiTheme();

  // Get selectedProduct from Redux to force re-render when it changes
  const selectedProduct = useSelector(
    (state: any) => state?.loginReducer?.loginState?.selectedProduct
  );

  const handleClickOutside = (event: MouseEvent): void => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fix: Add mappedProducts as dependency so products state updates when mappedProducts changes
  useEffect(() => {
    setProducts([]);
    mappedProducts.map((product: Product) => {
      const newValue = { ...getProductData(product), ...product };
      setProducts((prevState) => [...prevState, newValue]);
    });
  }, [mappedProducts]);

  // Force re-render when selectedProduct changes
  useEffect(() => {
    // This effect will trigger re-render when selectedProduct changes
    // The component will re-evaluate the selected state in dropdown options
  }, [selectedProduct]);

  const handleOptionClick = (product: Product) => {
    // Use the local products array which has merged data including product field
    const selectedProduct = products.find(
      (item) => item.id === product?.id
    );
    dispatch(
      updateSelectedProductOnPathChange({
        selectedProduct,
      })
    );
    push(generatePath(product?.route ?? ''));
  };

  const renderDropdown = () => {
    return (
      <div className='dropdown-options' id='dropdown-options'>
        {products.map((product: Product) => {
          return (
            <div
              className='option'
              key={product?.id}
              onClick={() => {
                handleOptionClick(product);
              }}
            >
              <div
                className={`dropdown-header ${
                  getSelectedProduct() === product?.product
                    ? 'selected-option'
                    : 'other-option'
                }`}
              >
                <div className='logo-container'>
                  <img
                    src={headerDropdownDetails[product?.product ?? '']?.icon}
                    alt='Plural'
                    height={'40px'}
                    width={'40px'}
                  />

                  <div className='product-detail-container'>
                    <p className={isCiti ? 'citi-product-title' : 'product-title'}>
                      {headerDropdownDetails[product?.product ?? '']?.text}
                    </p>
                    <img
                      src={isCiti ? imgURL['citi-logo'] : imgURL['pinelabs-online']}
                      alt={isCiti ? 'citi logo' : 'Pine Labs Online'}
                      height={'12px'}
                      width={'77px'}
                      className={isCiti ? 'citi-product-image' : 'product-image'}
                    />
                  </div>
                </div>
                {getSelectedProduct() === product?.product ? (
                  <img src={imgURL['check']} alt='chevron-down' />
                ) : (
                  <img
                    src={imgURL['unified-arrow-circle-right']}
                    alt='chevron-down'
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const handleDropdownClick = () => {
    mappedProducts?.length > 1 && setIsOpen(!isOpen);
  };

  return (
    <div ref={dropdownRef}>
      {isCollapsed ? (
        <div
          className={`${
            mappedProducts?.length > 1
              ? 'collpsed-container'
              : 'collpsed-container-disabled'
          }`}
          onClick={handleDropdownClick}
        >
          <div className='logo-container'>
            <img
              src={headerDropdownDetails[getSelectedProduct()]?.icon}
              width={'30px'}
              alt='Plural'
            />
            {mappedProducts?.length > 1 && (
              <img
                src={imgURL['unified-arrow-down']}
                alt='chevron-down'
                width={'20px'}
                className={isOpen ? 'rotate-image' : ''}
              />
            )}
          </div>
          {isOpen && renderDropdown()}
        </div>
      ) : (
        <>
          <div
            className={`${
              mappedProducts?.length > 1
                ? 'dropdown-container'
                : 'dropdown-container-disabled'
            }`}
            onClick={handleDropdownClick}
          >
            <div className='dropdown-header'>
              <div className='logo-container'>
                <img
                  src={headerDropdownDetails[getSelectedProduct()]?.icon}
                  alt='Plural'
                  height={'40px'}
                  width={'40px'}
                />
                <div className='product-detail-container'>
                  <p className={isCiti ? 'citi-product-title' : 'product-title'}>
                    {headerDropdownDetails[getSelectedProduct()]?.text}
                  </p>
                  {/* <img  
                    src={isCiti ? imgURL['citi-logo'] : imgURL['pinelabs-online']}
                    alt={isCiti ? 'citi logo' : 'PineLabs Online'}
                    height={'12px'}
                    width={'50px'}
                    className={isCiti ? 'citi-product-image' : 'product-image'}
                  /> */}
                   <img
                    src={isCiti ? imgURL['citi-logo'] : imgURL['pinelabs-online']}
                    alt={isCiti ? 'citi logo' : 'Pine Labs Online'}
                    className={isCiti ? 'citi-product-image' : 'product-image'}
                    height={'12px'}
                    width={'77px'}
                  />
                </div>
              </div>
              <div>
                {mappedProducts?.length > 1 && (
                  <img
                    src={imgURL['unified-arrow-down']}
                    alt='chevron-down'
                    className={isOpen ? 'rotate-image' : ''}
                  />
                )}
              </div>
            </div>
          </div>
          {isOpen && renderDropdown()}
        </>
      )}
    </div>
  );
};
const mapStateToProps = ({ loginReducer, sidebarReducer }) => ({
  isCollapsed: sidebarReducer.isCollapsed,
  loginState: loginReducer.loginState,
  productRefreshTokenState: loginReducer.productRefreshTokenState,
});
export default connect(mapStateToProps)(HeaderDropdown);
